import { Button, HighLowChart } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ScenariosData } from '~/react-query-hooks/scenarios/useScenarios';
import { useFlags } from '~/stores/use-flags/useFlags';
import { ChartLegend } from '~/views/dashboard/calendar-widget/calendar-event-drawer/drawer-content/earnings-event-drawer-content/earnings-chart/chart-legend/ChartLegend';

import styles from './EpsExpectationsSection.module.scss';

export interface HighLowMedianDataPoint {
  high: number;
  low: number;
  median: number;
  label?: string;
  horizon?: string;
}

export interface WhatIfChartProps {
  entityName: string;
  scenariosData: ScenariosData[];
  activeButtonLabel: string;
  handleDigIntoData: () => void;
  mappedScenariosData: HighLowMedianDataPoint[];
  width: number;
  chartHeight: number;
}

export const WhatIfChart = ({
  entityName,
  scenariosData,
  activeButtonLabel,
  handleDigIntoData,
  mappedScenariosData,
  width,
  chartHeight,
}: WhatIfChartProps) => {
  const { t } = useTranslation(['earnings', 'whatsNew']);
  const isUniversalDrawerEnabled = useFlags(state =>
    state.getFeatureFlagState('universal_drawer')
  );

  return (
    <>
      <div className={styles.flexRow}>
        <div className={styles.chartTitleLabel}>
          {t(
            'earnings:earningsInsight.drawer.earningsPreview.stockPerformanceAfterEarnings',
            {
              name: entityName,
              count: scenariosData[0]?.episodes?.length,
              expectation: activeButtonLabel,
            }
          )}
        </div>
        <Button
          className={styles.styledButton}
          label={t(
            'earnings:earningsInsight.drawer.earningsPreview.digIntoTheData'
          )}
          variant="empty"
          onClick={handleDigIntoData}
        />
      </div>
      <ChartLegend />
      <div className={styles.chartWrapper} data-testid="chart-container">
        <HighLowChart
          data={mappedScenariosData}
          width={width}
          height={chartHeight}
          variant={isUniversalDrawerEnabled ? 'tertiary' : 'secondary'}
          showAreaFill={!isUniversalDrawerEnabled}
        />
      </div>
    </>
  );
};
